module.exports = __webpack_public_path__ + "img/comma.209c2a30.svg";